export const USDollar = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});
